export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const SET_ID='SET_ID';
export const SET_PERMISSIONS_FIRST='SET_PERMISSIONS_FIRST';
